module.exports = __webpack_public_path__ + "static/media/facility-image-delete.5af6681c.svg";